import { LiaSaveSolid } from "react-icons/lia";

export const SaveIcon = ({ ...rest }) => {
  return <LiaSaveSolid {...rest} />;
};
